// removed by extract-text-webpack-plugin
module.exports = {"ObjectArray":"ObjectArray","ObjectArray--basket":"ObjectArray--basket","has-padding-bottom":"has-padding-bottom","ObjectArray--item":"ObjectArray--item","control-input":"control-input","delete-btn":"delete-btn","ObjectArray--addArrayItem":"ObjectArray--addArrayItem","addButton":"addButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Fields/ObjectArray/ObjectArray.scss
// module id = qBFl
// module chunks = 0